import * as React from 'react';

function SvgSelectBed(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="#fff" d="M0 0h24v24H0z" />
      <path d="M6 6h14.571v4.554L23 14.036V21H6V6z" fill="#FCCE01" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 2.85a.15.15 0 00-.15.15v6.15h2.3V7A1.85 1.85 0 019 5.15h6A1.85 1.85 0 0116.85 7v2.15h2.3V3a.15.15 0 00-.15-.15h-3a.85.85 0 010-1.7h3A1.85 1.85 0 0120.85 3v6.279c1.159.362 2 1.443 2 2.721v.356c.594.308 1 .929 1 1.644v6A1.85 1.85 0 0122 21.85h-1.3v1.3a.85.85 0 01-1.7 0v-1.3H4.7v1.3a.85.85 0 01-1.7 0v-1.3H2A1.85 1.85 0 01.15 20v-6a1.85 1.85 0 011-1.644V12c0-1.278.841-2.36 2-2.721V3A1.85 1.85 0 015 1.15h7a.85.85 0 010 1.7H5zm10.15 6.3V7a.15.15 0 00-.15-.15H9a.15.15 0 00-.15.15v2.15h6.3zM2.85 12c0-.635.515-1.15 1.15-1.15h16c.635 0 1.15.515 1.15 1.15v.15H2.85V12zm-1 2a.15.15 0 01.15-.15h20a.15.15 0 01.15.15v6a.15.15 0 01-.15.15H2a.15.15 0 01-.15-.15v-6z"
        fill="#595959"
      />
    </svg>
  );
}

export default SvgSelectBed;
